import React, { Component } from "react";

export default class Analysis extends Component {
  render() {
    return <div>Here is Analysis TAB</div>;
  }
}
